import React from "react";
import { ToggleGroup, ToggleGroupItem } from "@ndd/ui";
import type { TenureBand } from "../../../../../shared/metrics";
import { bandLabel } from "../../../lib/metrics-display";

const BANDS: readonly TenureBand[] = ["0-90", "90+"];

function isTenureBand(value: string): value is TenureBand {
  return BANDS.includes(value as TenureBand);
}

export function TenureSwitch({
  band,
  onBandChange,
}: {
  band: TenureBand;
  onBandChange: (band: TenureBand) => void;
}) {
  return (
    <ToggleGroup
      type="single"
      value={band}
      onValueChange={(next) => {
        if (isTenureBand(next)) onBandChange(next);
      }}
      aria-label="Targets by tenure band"
      className="gap-0 rounded-lg bg-secondary p-[2px]"
    >
      {BANDS.map((option) => (
        <ToggleGroupItem
          key={option}
          value={option}
          className="h-6 rounded-md border-0 bg-transparent px-3 text-xs text-muted-strong hover:bg-transparent hover:text-foreground data-[state=on]:bg-card data-[state=on]:text-foreground data-[state=on]:shadow-sm"
        >
          {bandLabel(option)}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
